import { DataService } from './dataService'
export const StoreService = {

    addStore: async (data) => {
        return DataService.post('/admin/add_store', data)
    },

    updateStore: async (data) => {
        return DataService.post('/admin/update_store', data)
    },

    // getRetailerDetails: async (data) => {
    //     return DataService.get('/admin/get_retailer_details', data)
    // },

    // updateRetailer: async (data) => {
    //     return DataService.post('/admin/update_retailer', data)
    // },
    // check_store_email: async(data) => {
    //     return DataService.post('/retailer/check_store_email',data)
    // }
}
